export default __webpack_public_path__ + "static/media/special.0f6caf63.svg";